import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { createPortal } from 'react-dom';
import styled, { withTheme } from 'styled-components';
import UserStore from '../flux/UserStore';
import JwtStore from '../flux/JwtStore';
import ThemeBuilder, {
  GlossaryButton,
  GlossaryModal,
  ThronAssetModal,
} from 'theme-builder'; // @todo 2018-06-01 Fix this please
import 'theme-builder/dist/index.css';
import withScrollDirection from '../hoc/withScrollDirection';
import { SCROLL_DIRECTION_UP } from '../hooks/useScrollDirection';
import themeResponsiveProperty from './responsive/themeResponsiveProperty';

function generateKey(chapters) {
  return chapters.map(chapter => chapter._id).join('+');
}

class ThemeViewer extends Component {
  static defaultProps = {
    chapters: [],
    contents: [],
    glossary: [],
    highlightWord: undefined,
    onExerciseComplete: id => new Promise(resolve => resolve()),
    onChapterEnter: index => new Promise(resolve => resolve()),
    onGlossaryTermShow: glossaryId => new Promise(resolve => resolve()),
  };

  state = {
    mediaZoom: null,
  };

  // @todo 2018-06-20 Consider extracting this into the parent components?
  onChapterListRequest = (chapter, contentId) => {
    const contentGlossary = this.props.glossary.find(item => item.contentId === contentId);

    const glossary = contentGlossary !== undefined
      ? contentGlossary.glossary.map(g => ({ ...g, selected: true, }))
      : [];

    return Promise.resolve(glossary);
  };

  onContentLanguageChange = (id, language) => {
    // We ignore the "language" because we already get only the current language
    // contents from the API.
    const contentTranslation = this.props.contents
      .find(({ content_id }) => content_id === id) || null;

    return Promise.resolve(contentTranslation);
  };

  render() {
    const isHeaderTabBarVisible = this.props.theme.isMobile && (
      this.props.scrollDirection === null ||
      this.props.scrollDirection === SCROLL_DIRECTION_UP
    );

    return (
      <Container style={{
        '--app-safe-area-inset-top': isHeaderTabBarVisible ? '3.375rem' : null,
        '--app-safe-area-inset-bottom': isHeaderTabBarVisible ? '4.625rem' : null,
      }}>
        {createPortal(
          <GlossaryModal
            isMobile={this.props.theme.isMobile}
            isTablet={this.props.theme.isTablet}
            onMediaZoomRequest={(source, options) => (
              this.setState({ mediaZoom: { source, options }})
            )}
            onGlossaryTermShow={this.props.onGlossaryTermShow}
          />,
          window.document.body
        )}

        {this.state.mediaZoom !== null && (
          ReactDOM.createPortal(
            <ThronAssetModal
              style={{ zIndex: 1000 /* GlossaryModal is 999 */, }}
              onCloseButtonClick={() => this.setState({ mediaZoom: null })}
              src={this.state.mediaZoom.source}
              options={this.state.mediaZoom.options} />,
            window.document.body,
          )
        )}

        {this.props.chapters.length > 0 && (
          <ThemeBuilder
            key={generateKey(this.props.chapters)}
            theme={{
              isMobile: this.props.theme.isMobile,
              isTablet: this.props.theme.isTablet,
              accentColor: this.props.theme.accentColor,
              accentColorBright: this.props.theme.accentColorBright,
              primaryBackgroundColor: this.props.theme.tertiaryBackgroundColor,
              primaryColor: '#fff',
              secondaryBackgroundColor: this.props.theme.accentColor,
              secondaryColor: '#fff',
              exerciseTutorialSources: {
                memory: themeResponsiveProperty('/exercise-tutorials/mobile-memory.gif', '/exercise-tutorials/tablet-memory.gif')(this.props),
                slotMachine: themeResponsiveProperty('/exercise-tutorials/mobile-slot-machine.gif', '/exercise-tutorials/tablet-slot-machine.gif')(this.props),
                exercise3: themeResponsiveProperty('/exercise-tutorials/mobile-exercise-3-4.gif', '/exercise-tutorials/tablet-exercise-3.gif')(this.props),
                exercise4: themeResponsiveProperty('/exercise-tutorials/mobile-exercise-3-4.gif', '/exercise-tutorials/tablet-exercise-4.gif')(this.props),
              },
            }}
            highlightWord={this.props.highlightWord}
            defaultLanguage={UserStore.getLanguageCode()}
            displayMode="STATIC"
            chapters={this.props.chapters}
            onExerciseComplete={this.props.onExerciseComplete}
            onChapterEnter={(i) => {
              this.props.onChapterEnter(i)
            }}
            onContentLanguageChange={this.onContentLanguageChange}
            onMediaZoomRequest={(source, options) => (
              this.setState({ mediaZoom: { source, options }})
            )}
            chapterButtons={[
              <GlossaryButton
                awsCredentials={JwtStore.getAwsCredentials()}
                onChapterListRequest={this.onChapterListRequest} />
            ]}
          />
        )}
      </Container>
    );
  }
}

export default withScrollDirection(withTheme(ThemeViewer));

const Container = styled.div`
  line-height: 1.5;
  font-weight: 200;
  background-color: ${props => props.theme.primaryBackgroundColor};
`;
